import React from 'react'

import FutureElectionForm from './FutureElectionForm/FutureElectionForm'
import { LeadTypes } from '../../includes/leadConstants'
import Nav from '../Nav/Nav'

import futureElectionSceneContainer from './futureElectionSceneContainer'
import './FutureElectionScene.css'

export const FutureElectionScene = ({
  futureFormSubmitted,
  isFutureYear,
}) => (
  <div className="FutureElectionScene">
    <Nav slim={true} />
    <div className="container">
      <div className="row">
        <div className="col-md-8 offset-md-2">
          {futureFormSubmitted ? (
            <header className="my-5 text-center">
              <h2>Thank you!</h2>
              <p>A representative from the <strong>{process.env.REACT_APP_SITE_TITLE}</strong> will reach out to you shortly.</p>
            </header>
          ) : (
            <div>
              <header className="my-5 text-center">
                <p>We are not yet aware of any positions with upcoming elections in your area.</p>
                {isFutureYear ? (
                  <p>The {process.env.REACT_APP_SITE_TITLE} is hosting professional candidate trainings to help you navigate and explore opportunities in public service for the future. Sign up below and we'll be in touch about upcoming opportunities and trainings near you.</p>
                ) : (
                  <p>The {process.env.REACT_APP_SITE_TITLE} is hosting professional candidate trainings to help you navigate and explore opportunities in public service for the future. Sign up below and we'll be in touch about upcoming opportunities and trainings near you.</p>
                )}
              </header>
              <FutureElectionForm
                campaign="future_election"
                lead_type={LeadTypes.FULL}
                position_id={null} // No position related to this lead
                tenant_id={process.env.REACT_APP_TENANT_ID}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
)

export default futureElectionSceneContainer(FutureElectionScene)


// WEBPACK FOOTER //
// ./src/components/FutureElectionScene/FutureElectionScene.js